import React, { useState } from "react";
import hermesIcon from "../../../public/hermes-icon.png";

interface LoginPageProps {
  error?: string | null;
}

export function LoginPage({ error }: LoginPageProps) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [loginError, setLoginError] = useState<string | null>(error || null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoginError(null);

    if (!email.endsWith("@arcticleaf.com")) {
      setLoginError("Only @arcticleaf.com emails are allowed");
      return;
    }

    setSending(true);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) {
        setLoginError(data.error || "Failed to send login link");
      } else {
        setSent(true);
      }
    } catch (err) {
      setLoginError((err as Error).message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img
          src={hermesIcon}
          alt="Project Hermes"
          className="login-icon"
        />
        <h1 className="login-title">Project Hermes</h1>
        <p className="login-subtitle">Sign in with your Arctic Leaf email</p>

        {sent ? (
          <div className="login-sent">
            <p>Check your email for a sign-in link.</p>
            <p className="login-hint">The link expires in 15 minutes.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@arcticleaf.com"
                required
                autoFocus
              />
            </div>
            {loginError && (
              <div className="login-error">{loginError}</div>
            )}
            <button
              type="submit"
              className="btn btn-primary"
              disabled={sending}
              style={{ width: "100%" }}
            >
              {sending ? "Sending..." : "Send Magic Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
